/**
 * 班级api
 * 班级api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The TeamCourseCreateForm model module.
   * @module user/model/TeamCourseCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TeamCourseCreateForm</code>.
   * @alias module:user/model/TeamCourseCreateForm
   * @class
   */
  var exports = function() {
    var _this = this;


  };

  /**
   * Constructs a <code>TeamCourseCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:user/model/TeamCourseCreateForm} obj Optional instance to populate.
   * @return {module:user/model/TeamCourseCreateForm} The populated <code>TeamCourseCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'courseId')) {
        obj['courseId'] = ApiClient.convertToType(data['courseId'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 课程id
   * @member {Integer} courseId
   */
  exports.prototype['courseId'] = undefined;



  export default exports;
;


